<template>
  <!-- 修改地区表对话框 -->
  <el-dialog
      title="修改地区排序"
      :visible.sync="editDialogVisible"
      width="600px"
  >
    <el-form ref="editFormRef" :model="editForm" label-width="80px">
      <el-row>
        <el-col :span="24">
            <el-form-item label="名称" prop="name">
              <el-input disabled v-model="editForm.name" placeholder="请输入名称"/>
            </el-form-item>
        </el-col>
        <el-col :span="24">
            <el-form-item label="排序" prop="sort">
              <el-input v-model="editForm.sort" placeholder="请输入排序"/>
            </el-form-item>
        </el-col>
        <el-col :span="24">
            <el-form-item label="热门城市" prop="enumHot">
              <el-select style="width: 100%;" v-model="editForm.enumHot" placeholder="是否热门城市">
                <el-option
                  v-for="item in defaultOptions"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="显示首页" prop="enumHot">
            <el-select style="width: 100%;" v-model="editForm.enumHomePage" placeholder="是否显示在首页">
              <el-option
                v-for="item in defaultOptions"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="cancel">取 消</el-button>
      <el-button @click="modifyArea">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import {updateArea} from "@/api/area/area";
import {getPostOrDeleteData} from "@/utils/code";
import {payYesNo} from '@/js/enum.js'

export default {
  name: "editArea",
  data() {
    return {
      editForm: {}, //修改
      editDialogVisible: false,
      defaultOptions: payYesNo
    }
  },
  methods: {
    cancel() {
      this.editDialogVisible = false
      this.editForm = {}
    },
    editDialog(row) {
      this.editForm = JSON.parse(JSON.stringify(row));
      this.editDialogVisible = true;
    },
    modifyArea() {
      this.$refs.editFormRef.validate(async (valid) => {
        if (!valid) return;
        delete this.editForm.children
        updateArea(this.editForm.id, this.editForm).then((response) => {
          let data = getPostOrDeleteData(response);
          if (data !== null) {
            this.$emit('refresh-list')
            this.editDialogVisible = false;
          }
        })
      });
    },
  }
}
</script>

<style scoped>

</style>
